export default class FormValidationError {
  constructor(errors: { [field: string]: string }) {
    Object.assign(this, errors);
  }
}
